import React, { useEffect, useState } from "react";
import moment from "moment";
import DisplaySummaryQuestions from "./components/DisplaySummaryQuestions";
import NavigationComponent from "../../calendar/components/NavigationComponent";
import DateSelectorNew from "./components/DateSelectorNew";
import SvgIcon from "../../../../parts/SvgIcon";
import {
  displayDateRange,
  frequencyLimit,
} from "../../../../utils/questionnaire";
import submit from "submit-form";
import { AthleteSelect } from "../../../../parts/inputs/athlete-select-new";
import { AthleteLinks } from "../../../../parts/athlete-links";
import getAvatarUrl from "../../../../utils/get-avatar-url";
import { ReportsBackHandler } from "../../calendar/components/ReportsBackHandler";
import BackButton from "../../../../parts/BackButton";

const handleSelectAnswer = (answer) => {
  submit("/actions/refresh?", {
    method: "GET",
    body: {
      checkInDate: moment(answer.utcDate, "YYYYMMDD").format("YYYY-MM-DD"),
      checkInFrequency: answer.questionnaire.questionnaireFrequency,
      athleteSwitch: false,
    },
  });
};

const WeekDisplay = ({ selectedAnswer, datesWithAnswers }) => {
  const { questionnaire, utcDate } = selectedAnswer;
  const { questionnaireFrequency } = questionnaire;
  const timePeriod = frequencyLimit[questionnaireFrequency];

  const currentAnswer = datesWithAnswers.findIndex(
    (answer) => answer._id === selectedAnswer._id
  );

  const end = moment(utcDate, "YYYYMMDD").format("YYYY-MM-DD");
  const start = moment(utcDate, "YYYYMMDD")
    .subtract(timePeriod - 1, "days")
    .format("YYYY-MM-DD");

  return (
    <div>
      <button
        data-button-type="text-white"
        data-icon-only
        onClick={() => {
          if (currentAnswer > 0) {
            const previousAnswer = datesWithAnswers[currentAnswer - 1];

            handleSelectAnswer(previousAnswer);
          }
        }}
        id={`${selectedAnswer._id}-left-arrow`}
      >
        <SvgIcon src="/img/new-icons/arrow-left.svg" />
      </button>
      <span className="composition-date-display">
        {displayDateRange(start, end)}
      </span>
      <button
        data-button-type="text-white"
        data-icon-only
        onClick={() => {
          if (currentAnswer < datesWithAnswers.length - 1) {
            const nextAnswer = datesWithAnswers[currentAnswer + 1];

            handleSelectAnswer(nextAnswer);
          }
        }}
        id={`${selectedAnswer._id}-right-arrow`}
      >
        <SvgIcon src="/img/new-icons/arrow-right.svg" />
      </button>
    </div>
  );
};

const CheckinSummary = ({ locals, selectedAnswer }) => {
  const {
    dailyStats,
    activeUser,
    athlete,
    query,
    pathname,
    nutritionPlans,
    dayPersonalRecords,
    activeExercises,
  } = locals;
  const { units } = activeUser;

  const [datesWithAnswers, setDatesWithAnswers] = useState([]);
  const [threeMonthData, setThreeMonthData] = useState([]);

  useEffect(() => {
    const filteredStats = dailyStats
      .slice()
      .filter((stats) => stats.questionnaire)
      .sort((a, b) => a.utcDate - b.utcDate);

    setDatesWithAnswers(filteredStats);
  }, [dailyStats]);

  useEffect(() => {
    if (selectedAnswer) {
      const startDate = moment(selectedAnswer.utcDate, "YYYYMMDD").subtract(
        3,
        "months"
      );

      const threeMonthStats = dailyStats
        .slice()
        .filter(
          (stat) =>
            stat.utcDate >= Number(startDate.format("YYYYMMDD")) &&
            stat.utcDate <= selectedAnswer.utcDate
        )
        .sort((a, b) => a.utcDate - b.utcDate);

      setThreeMonthData(threeMonthStats);
    }
  }, [dailyStats, selectedAnswer]);

  return (
    <main role="reports-wrapper" className="check-in-summary">
      <NavigationComponent
        query={query}
        text="Calendar Day View"
        pathName={pathname}
        classNames="mobile-hidden"
      />

      <div className="athlete-section-header only-show-mobile">
        <AthleteLinks
          athlete={athlete}
          pathName={pathname}
          classNames={"only-show-mobile"}
          query={query}
        />
        <div className="athlete-select dropdown-athlete">
          <div
            className="avatar"
            style={{
              backgroundImage: `url(${getAvatarUrl(athlete?._id)})`,
            }}
          />
          <AthleteSelect locals={locals} />
        </div>
      </div>

      <article id="check-in-summary" role="report-content">
        <header>
          <div className="top-header only-show-mobile">
            <ReportsBackHandler title={"Check-in Summary"} locals={locals} />
            <DateSelectorNew
              datesWithAnswers={datesWithAnswers}
              selectedAnswer={selectedAnswer}
            />
          </div>
          <hgroup className="flex gap-2 items-center mb-8 !justify-start">
            {query.showBack && <BackButton />}
            <h2 className="force-mobile-hidden">Check-in Summary</h2>
          </hgroup>
          <DateSelectorComponent
            datesWithAnswers={datesWithAnswers}
            selectedAnswer={selectedAnswer}
          />
        </header>

        <div className="CheckIn-answers-row">
          {selectedAnswer ? (
            <DisplaySummaryQuestions
              answerStats={selectedAnswer}
              dailyStats={dailyStats}
              athlete={athlete}
              date={String(selectedAnswer.utcDate)}
              threeMonthData={threeMonthData}
              units={units}
              nutritionPlans={nutritionPlans}
              dayPersonalRecords={dayPersonalRecords}
              locals={locals}
              query={query}
              activeExercises={activeExercises}
            />
          ) : (
            <span>
              Select a check-in summary from the drop-down list to review
            </span>
          )}
        </div>
      </article>
    </main>
  );
};

export default CheckinSummary;

const DateSelectorComponent = ({ datesWithAnswers, selectedAnswer }) => {
  return (
    <hgroup>
      <DateSelectorNew
        datesWithAnswers={datesWithAnswers}
        selectedAnswer={selectedAnswer}
      />
      {!!selectedAnswer && (
        <div role="month-handler">
          <WeekDisplay
            datesWithAnswers={datesWithAnswers}
            selectedAnswer={selectedAnswer}
          />
        </div>
      )}
    </hgroup>
  );
};
